import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import AccountModal from "../../../../commons/components/AccountModal";
import Loading from "../../../../commons/components/loading";
import Message from '../../../../commons/utils/message';
import ServiceUser from '../../../../services/users';

import {
    usersSetShowUnlinkModal,
    usersSetSelectedPartner,
} from '../../../../store/actions/usersActions';

function ModalUnlink({onSave}){
    const { showUnlinkModal, selectedPartner, selectedUser } = useSelector((state) => state.users);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    function renderButtons() {
        return (
            <>
                <button key="cancel" onClick={handleClear} className="ant-btn">Cancelar</button>
                <button key="confirm" onClick={handleUnlink} className="ant-btn ant-btn-dangerous">Confirmar</button>
            </>
        )
    }

    function handleClear() {
        dispatch(usersSetShowUnlinkModal(false));
        dispatch(usersSetSelectedPartner({}));
        setLoading(false);
    }

    async function handleUnlink(){
        let body = {
            'user_id': selectedUser.id,
            'partner_id': selectedPartner.id,
            'environment': 'PROD'
        }

        const responseUnlink = await ServiceUser.unlink(body)
        if (responseUnlink) {
            Message.showSuccess("Permissão desvinculada!")
            onSave();
            handleClear();
        }
    }

    function renderMessage() {
        if (loading) {
            return (
                <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                    <Loading width={50} height={50} />
                </div>
            )
        } else {
            return (
                <div>
                    <p>Todas as permissões deste usuário para o parceiro {selectedPartner.trading_name} serão removidas.</p>
                </div>
            )
        }
    }

    return (
        <AccountModal
            visible={showUnlinkModal}
            title={"Remover permissões"}
            onCancel={handleClear}
            footer={renderButtons()}>
            {renderMessage()}
        </AccountModal>
    )
}

export default ModalUnlink;